import { toJS } from 'mobx';

import { LocationReactorResult } from 'bernie-client';

import { SearchResultsStore } from 'stores/search-results-store';

import { hasQueryParamChanged } from './utils';

export const processClientSideDefaultRequestFields = (
  isServer: boolean,
  searchResults: SearchResultsStore,
  nextQuery?: object
): LocationReactorResult => {
  const defaultRequestFields = toJS(searchResults.defaultRequestFields);

  let newQuery = null;

  if (!isServer && defaultRequestFields && typeof defaultRequestFields === 'object' && Object.keys(defaultRequestFields).length > 0) {
    const shouldProcess =
      !nextQuery ||
      Object.keys(defaultRequestFields).some(key =>
        Boolean(!nextQuery[key] || hasQueryParamChanged(nextQuery[key], defaultRequestFields[key]))
      );

    if (shouldProcess) {
      newQuery = { query: defaultRequestFields, replace: true };
    }

    searchResults.defaultRequestFields = {};
  }

  return newQuery;
};
